/* ==========================================================================
   CM CART — WARENKORB-BILD VORLADEN
   --------------------------------------------------------------------------
   Diese Datei macht GENAU EINE Sache: sie laedt das Produktbild in der
   Groesse vor, die der Warenkorb spaeter anzeigt. Sie schreibt NICHTS ins
   DOM, oeffnet NICHTS und sendet keinen Request an /cart/add.

   WARUM SO KLEIN — DIE GESCHICHTE DAZU
   --------------------------------------------------------------------------
   Hier stand eine deutlich groessere Fassung, die nach dem Klick sofort eine
   fertige Warenkorb-Zeile in den Drawer gemalt hat ("optimistisches
   Rendern"), damit der Kunde nicht auf den Server wartet.

   Die Idee war richtig, die Umsetzung hat aber dreimal hintereinander gegen
   die Zustandslogik des Themes verloren:

     1. Das eigene Oeffnen des Drawers hat im Horizon-Theme
        shouldAutoOpen ausgehebelt (assets/cart-drawer.js). Folge: bei leerem
        Warenkorb blieb "Your cart is empty" stehen, und der Inhalt kam wegen
        eines blockierenden View-Transitions gar nicht mehr an.

     2. Die gemalte Zeile sah anders aus als die echte: der Titel wurde nicht
        am Pipe gekuerzt (snippets/product-title-display.liquid macht das
        server-seitig), und Optionen wurden mit " / " statt ",&nbsp;"
        getrennt.

     3. Im Dawn-Theme hat das Oeffnen den Scroll-Lock ausgeloest
        (position:fixed auf body) — mitten in der Klick-Sequenz, bevor der
        Browser submit feuert. Das zweite Produkt landete dadurch gar nicht
        mehr im Warenkorb.

   LEHRE: Die Themes besitzen ihre Warenkorb-Anzeige. Ein zweites System, das
   von aussen dieselben Zustaende anfasst, ist nicht beherrschbar — jeder
   behobene Konflikt legt den naechsten frei.

   Die eigentlichen Geschwindigkeitsgewinne kommen ohnehin von woanders und
   stecken jetzt direkt im Theme-Code:
     - ein Request weniger pro Add-to-cart (assets/product-form.js)
     - kein Warten mehr auf /cart.json, bevor die Anzeige aktualisiert wird
     - keine Zeitschleifen mehr (Polling alle 80/100/150ms)
     - keine kuenstlichen Mindestwartezeiten
     - hohe Prioritaet fuer den Kauf-Request

   Was hier bleibt, ist der Teil, der nichts kaputtmachen kann: das Bild liegt
   beim Oeffnen des Drawers bereits dekodiert im Cache und poppt nicht nach.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__cmCartEngine) return;
  window.__cmCartEngine = true;

  var cache = new Map();

  function preload(url, high) {
    if (!url || cache.has(url)) return;

    var img = new Image();
    img.decoding = 'async';
    try {
      img.fetchPriority = high ? 'high' : 'low';
    } catch (e) {
      /* aelterer Browser — unkritisch */
    }
    img.src = url;
    cache.set(url, img);

    /* Dekodieren vorziehen, sonst baut der Browser das Bild erst auf, wenn es
       sichtbar wird — also genau im Moment des Einblendens. */
    if (img.decode) img.decode().catch(function () {});
  }

  /* Liest den JSON-Block, den das Liquid-Snippet neben den Kauf-Button legt.
     Die Bild-URL darin ist ZEICHENGENAU die, die der Warenkorb rendert — nur
     dann trifft der Browser-Cache. */
  function imageFor(button) {
    try {
      var scope =
        button.closest('add-to-cart-component') ||
        button.closest('product-form-component') ||
        button.closest('product-form') ||
        button.closest('form');

      var el = scope && scope.querySelector('script[data-cm-cart-thumbs]');
      if (!el) return null;

      if (el.__data === undefined) {
        try {
          el.__data = JSON.parse(el.textContent || '{}');
        } catch (e) {
          el.__data = null;
        }
      }
      if (!el.__data || !el.__data.items) return null;

      var input = scope.querySelector('input[name="id"], [name="id"]');
      var id = input && input.value ? String(input.value) : null;
      var entry = (id && el.__data.items[id]) || el.__data.items['default'];

      return entry ? entry.img : null;
    } catch (e) {
      return null;
    }
  }

  function buttonFrom(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('add-to-cart-component button[name="add"], button[name="add"], [id^="BuyButtons-ProductSubmitButton-"]');
    if (!btn) return null;
    /* Buttons im Warenkorb selbst sind keine Kauf-Buttons. */
    if (btn.closest('.cart-drawer__summary, cart-items-component')) return null;
    return btn;
  }

  function warm(e, high) {
    var btn = buttonFrom(e.target);
    if (btn) preload(imageFor(btn), high);
  }

  document.addEventListener('pointerdown', function (e) { warm(e, true); }, { passive: true, capture: true });
  document.addEventListener('pointerover', function (e) { warm(e, false); }, { passive: true });
  document.addEventListener('focusin', function (e) { warm(e, false); });

  /* Nach einem Variantenwechsel das Bild der neuen Variante nachziehen. Das
     versteckte Feld input[name="id"] wird erst nach dem change-Event
     aktualisiert — daher zwei Frames Abstand statt eines festen Timeouts. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var form = t.closest('product-form-component');
    if (!form) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var btn = form.querySelector('add-to-cart-component button[name="add"], button[name="add"], [id^="BuyButtons-ProductSubmitButton-"]');
        if (btn) preload(imageFor(btn), false);
      });
    });
  });
})();
